export const ASSET_CLASS_ORDER = [
	'US Equities',
	'Australian Equities',
	'Non-US/International Equities',
	'International/Global Equities',
	'International Equities',
	'Emerging Market Equities',
	'Developed Market Equities',
	'Property & Infrastructure',
	'Sector Equities',
	'US Fixed Income',
	'Australian Fixed Income',
	'Non-US/International Fixed Income',
	'International/Global Fixed Income',
	'International Fixed Income',
	'Global Fixed Income',
	'Multi-Asset',
	'Alternatives',
	'Cash & Cash Alternatives',
	'Cash'
];

// https://dev.azure.com/1A4D/Aladdin%20Wealth%20Clients/_git/arwm-configs?path=/clients/BWN/std/ARWM/AC.awaConfiguration.json&_a=contents&version=GBmaster
// Check under acAssetClass
export const ASSET_CLASS_LABEL_MAPPING = {
	usEquities: 'US Equities',
	globalEquities: 'International/Global Equities',
	sectorEquities: 'Sector Equities',
	usFixedIncome: 'US Fixed Income',
	globalFixedIncome: 'International/Global Fixed Income',
	multiAsset: 'Multi-Asset',
	alternatives: 'Alternatives',
	cash: 'Cash & Cash Alternatives'
};

// https://dev.azure.com/1A4D/Aladdin%20Wealth%20Clients/_git/arwm-configs?path=/clients/BWN/std/ARWM/AC.awaConfiguration.json&_a=contents&version=GBmaster
// Check under subAssetClass & cmaAssetClass
export const SUB_ASSET_CLASS_LABEL_MAPPING = {
	allocation15to30: 'Multi-Asset Blend: 15%-30% Equity',
	allocation30to50: 'Multi-Asset Blend: 30%-50% Equity"',
	allocation50to70: 'Multi-Asset Blend: 50%-70% Equity',
	allocation70to85: 'Multi-Asset Blend: 70%-85% Equity',
	allocation85plus: 'Multi-Asset Blend: 85%+ Equity',
	alternatives: 'Diversifier Alternatives',
	asiaPacStocks: 'Asia/Pacific ex Japan Equities',
	bankLoans: 'Bank Loans',
	cash: 'Cash & Cash Alternatives',
	chinaStocks: 'China Equities',
	commodities: 'Commodities',
	communicationStocks: 'Communications Sector Equities',
	consumerDiscrStocks: 'Consumer Discretionary Sector Equities',
	consumerStapleStocks: 'Consumer Staples Sector Equities',
	convertibles: 'Convertible Bonds',
	coreBonds: 'Core Bonds',
	creditBonds: 'Credit Bonds',
	derivatives: 'Derivative Income',
	EMequitiesCountrySpecific: 'EM Equities - Country Specific',
	emergingMarketBonds: 'Emerging Market Bonds',
	emergingMarketBondsLocal: 'Emerging Market Bonds (Local Currency)',
	emergingMarketEquities: 'Emerging Market Equities',
	energyStocks: 'Energy Sector Equities',
	equityPreciousStocks: 'Precious Metal Equities',
	europeanStocks: 'European Equities',
	financialStocks: 'Financial Sector Equities',
	globalBonds: 'Global Bonds',
	globalExUsEquitiesCountrySpecific: 'Global ex-US Equities - Country Specific',
	globalHedgeFunds: 'Global Hedge Funds',
	globalLargeCapStocks: 'Global Large Cap Equities',
	globalRealEstate: 'Global Real Estate Equities',
	globalSmallCapStocks: 'Global Small Cap Equities',
	globalStocks: 'Global Equities',
	GovtBonds: 'Government Bonds',
	healthcareStocks: 'Health Sector Equities',
	highYieldBonds: 'High Yield Bonds',
	highYieldMunis: 'High Yield Municipal Bonds',
	industrialsStocks: 'Industrials Sector Equities',
	inflationProtectedBonds: 'Inflation-Protected Bonds',
	infrastructureStocks: 'Infrastructure Sector Equities',
	japanStocks: 'Japan Equities',
	mlps: 'MLPs',
	multiAsset: 'Multi Asset',
	multiSectorBonds: 'Multi Sector Bond',
	municipalBonds: 'Municipal Bonds',
	nonUsLargeCapStocks: 'Global ex-US Large Cap Equities',
	nonUsSmallCapStocks: 'Global ex-US Small Cap Equities',
	nonUsStocks: 'World ex-US Equities',
	nontraditionalBonds: 'Nontraditional Bond',
	otherFixedIncome: 'Other Fixed Income',
	OtherSectorStocks: 'Other Sector Equities',
	preferredStock: 'Preferred Stock',
	privateCredit: 'Private Credit',
	privateEquity: 'Private Equity',
	shortGovernment: 'Short-Term Treasury Bonds',
	shortMuniBonds: 'Short-Term Municipal Bonds',
	shortTermBonds: 'Short-Term Bonds',
	technologyStocks: 'Information Technology Sector Equities',
	treasuryBills: 'USD Cash',
	usAggBonds: 'US Aggregate Bonds',
	usLargeCapStocks: 'US Large Cap Equities',
	usMidCapStocks: 'US Mid Cap Equities',
	usRealEstate: 'US Real Estate Equities',
	usSmallCapStocks: 'US Small Cap Equities',
	utilitiesStocks: 'Utilities Sector Equities'
};

export class AssetClassType {
	public static readonly CASH: string = 'Cash';
}
